<template>
  <CalendarioEscolar />
</template>

<script>
import CalendarioEscolar from '@/components/CalendarioEscolar';
export default {
  components: {
    CalendarioEscolar,
  }
}
</script>

<style>

</style>
